import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'
import style from './Option.module.css'

type OptionProps = {
  children: ReactElement | Array<ReactElement> | string
  isActive: boolean
}

export const Option: FC<OptionProps> = ({ children, isActive }): ReactElement => {
  const className = classNames(style.option, {
    [style.selectedOption]: isActive,
  })

  return (
    <div className={className}>
      <div className={style.optionContent}>
        {children}
        {isActive}
      </div>
    </div>
  )
}

Option.displayName = 'Option'
